"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_helmet_1 = require("react-helmet");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var App_1 = __importDefault(require("./App"));
var Auth_1 = __importDefault(require("App/layouts/Auth"));
var Public_1 = __importDefault(require("App/layouts/Public"));
require("antd/lib/layout/style");
var ELayoutTypes;
(function (ELayoutTypes) {
    ELayoutTypes["public"] = "public";
    ELayoutTypes["auth"] = "auth";
    ELayoutTypes["app"] = "app";
})(ELayoutTypes || (ELayoutTypes = {}));
var Layouts = (_a = {},
    _a[ELayoutTypes.public] = Public_1.default,
    _a[ELayoutTypes.auth] = Auth_1.default,
    _a[ELayoutTypes.app] = App_1.default,
    _a);
var HootsuiteContentSourceLayout = function (_a) {
    var children = _a.children;
    var _b = react_1.useState(ELayoutTypes.public), layout = _b[0], setLayout = _b[1];
    var oidc = react_redux_1.useSelector(function (state) { return state.oidc; });
    var location = react_router_dom_1.useLocation();
    // Layout Rendering
    var getLayout = function (pathname) {
        if (/^\/authentication(?=\/|$)/i.test(pathname)) {
            return ELayoutTypes.auth;
        }
        if (pathname === '/') {
            return ELayoutTypes.public;
        }
        return ELayoutTypes.app;
    };
    react_1.useEffect(function () {
        setLayout(getLayout(location.pathname));
    }, [location]);
    var BootstrappedLayout = function () {
        var pathname = location.pathname;
        var Container = Layouts[layout];
        // in other case render previously set layout
        return react_1.default.createElement(Container, null, children);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.Helmet, { title: "Admin Panel", titleTemplate: "Accalli/o | %s" }),
        BootstrappedLayout()));
};
exports.default = HootsuiteContentSourceLayout;
//# sourceMappingURL=index.js.map